module.exports = __webpack_public_path__ + "src/images/begin-step-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/begin-step-2.jpg
// module id = 1137
// module chunks = 0